<template>
  <div class="content-box">
    <fieldset v-for="(db, index) in dbrecs" :key="index">
      <legend>
        <span>{{ db.connectionName }}</span>
      </legend>
      <v-row>
        <v-col cols="6">
          <v-row>
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-col cols="7"><p class="label">{{ $t('ssr.title.conn') }}</p></v-col>
            <v-col cols="5"><v-text-field :value="db.connectionName" outlined dense hide-details readonly></v-text-field></v-col>
          </v-row>
          <v-row>
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-col cols="7"><p class="label">{{ $t('ssr.title.db.req.total') }}</p></v-col>
            <v-col cols="5"><v-text-field :value="(db.phyreadcnt + db.phyupdcnt + db.phydelcnt + db.phyinscnt) | comma" outlined dense hide-details readonly></v-text-field></v-col>
          </v-row>
          <v-row>
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-col cols="7"><p class="label">{{ $t('ssr.title.db.proc.call') }}</p></v-col>
            <v-col cols="5"><v-text-field :value="db.dbprocnt | comma" outlined dense hide-details readonly></v-text-field></v-col>
          </v-row>
        </v-col>
        <v-col cols="6">
          <v-row>
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-col cols="7"><p class="label">{{ $t('ssr.title.req.time') }}</p></v-col>
            <v-col cols="5"><v-text-field :value="(db.readdirti + db.readseqti + db.updti + db.delti + db.insti) | millis | comma" outlined dense hide-details readonly></v-text-field></v-col>
          </v-row>
          <v-row>
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-col cols="7"><p class="label">{{ $t('ssr.title.commit.time') }}</p></v-col>
            <v-col cols="5"><v-text-field :value="db.committi | millis | comma" outlined dense hide-details readonly></v-text-field></v-col>
          </v-row>
          <v-row>
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-col cols="7"><p class="label">{{ $t('ssr.title.db.proc.time') }}</p></v-col>
            <v-col cols="5"><v-text-field :value="db.dbprocti | millis | comma" outlined dense hide-details readonly></v-text-field></v-col>
          </v-row>
        </v-col>
      </v-row>
      <!-- <v-row><v-col cols="12" style="height:29px"></v-col></v-row> -->
      <v-row>
        <v-col cols="12">
          <fieldset>
            <v-row>
              <v-col cols="3">
                <p>Type of ABAP request</p>
              </v-col>
              <v-col cols="9">
                <div class="d-flex input-list">
                  <p>{{ $t('ssr.title.db.rows') }}</p>
                  <p>{{ $t('ssr.title.reqs') }}</p>
                  <p>{{ $t('ssr.title.req.buf') }}</p>
                  <p>{{ $t('ssr.title.db.call') }}</p>
                  <p>{{ $t('ssr.title.req') }} <br />{{ $t('ssr.title.time.ms') }}</p>
                  <p>{{ $t('ssr.title.avg.time') }}</p>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <p>Total</p>
              </v-col>
              <v-col cols="9">
                <div class="d-flex input-list">
                  <v-text-field :value="(db.readdirrec + db.readseqrec + db.updrec + db.delrec + db.insrec) | comma" outlined dense hide-details readonly></v-text-field>
                  <v-text-field :value="(db.readdircnt + db.readseqcnt + db.updcnt + db.delcnt + db.inscnt) | comma" outlined dense hide-details readonly></v-text-field>
                  <v-text-field :value="(db.readdirbuf + db.readseqbuf) | comma" outlined dense hide-details readonly></v-text-field>
                  <v-text-field :value="(db.phyreadcnt + db.phyupdcnt + db.phydelcnt + db.phyinscnt) | comma" outlined dense hide-details readonly></v-text-field>
                  <v-text-field :value="(db.readdirti + db.readseqti + db.updti + db.delti + db.insti) | millis | comma" outlined dense hide-details readonly></v-text-field>
                  <v-text-field :value="average(db) | millis | comma" outlined dense hide-details readonly></v-text-field>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <p>Direct read</p>
              </v-col>
              <v-col cols="9">
                <div class="d-flex input-list">
                  <v-text-field :value="db.readdirrec | comma" outlined dense hide-details readonly></v-text-field>
                  <v-text-field :value="db.readdircnt | comma" outlined dense hide-details readonly></v-text-field>
                  <v-text-field :value="db.readdirbuf | comma" outlined dense hide-details readonly></v-text-field>
                  <div></div>
                  <v-text-field :value="db.readdirti | millis | comma" outlined dense hide-details readonly></v-text-field>
                  <v-text-field :value="(Math.floor(db.readdirti / (db.readdirrec === 0 ? 1 : db.readdirrec) / 100) / 10) | comma" outlined dense hide-details readonly></v-text-field>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <p>Sequential read</p>
              </v-col>
              <v-col cols="9">
                <div class="d-flex input-list">
                  <v-text-field :value="db.readseqrec | comma" outlined dense hide-details readonly></v-text-field>
                  <v-text-field :value="db.readseqcnt | comma" outlined dense hide-details readonly></v-text-field>
                  <v-text-field :value="db.readseqbuf | comma" outlined dense hide-details readonly></v-text-field>
                  <v-text-field :value="db.phyreadcnt | comma" outlined dense hide-details readonly></v-text-field>
                  <v-text-field :value="db.readseqti | millis | comma" outlined dense hide-details readonly></v-text-field>
                  <v-text-field :value="(Math.floor(db.readseqti / (db.readseqrec === 0 ? 1 : db.readseqrec) / 100) / 10) | comma" outlined dense hide-details readonly></v-text-field>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <p>Update</p>
              </v-col>
              <v-col cols="9">
                <div class="d-flex input-list">
                  <v-text-field :value="db.updrec | comma" outlined dense hide-details readonly></v-text-field>
                  <v-text-field :value="db.updcnt | comma" outlined dense hide-details readonly></v-text-field>
                  <div></div>
                  <v-text-field :value="db.phyupdcnt | comma" outlined dense hide-details readonly></v-text-field>
                  <v-text-field :value="db.updti | millis | comma" outlined dense hide-details readonly></v-text-field>
                  <v-text-field :value="(Math.floor(db.updti / (db.updrec === 0 ? 1 : db.updrec) / 100) / 10) | comma" outlined dense hide-details readonly></v-text-field>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <p>Delete</p>
              </v-col>
              <v-col cols="9">
                <div class="d-flex input-list">
                  <v-text-field :value="db.delrec | comma" outlined dense hide-details readonly></v-text-field>
                  <v-text-field :value="db.delcnt | comma" outlined dense hide-details readonly></v-text-field>
                  <div></div>
                  <v-text-field :value="db.phydelcnt | comma" outlined dense hide-details readonly></v-text-field>
                  <v-text-field :value="db.delti | millis | comma" outlined dense hide-details readonly></v-text-field>
                  <v-text-field :value="(Math.floor(db.delti / (db.delrec === 0 ? 1 : db.delrec) / 100) / 10) | comma" outlined dense hide-details readonly></v-text-field>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <p>Insert</p>
              </v-col>
              <v-col cols="9">
                <div class="d-flex input-list">
                  <v-text-field :value="db.insrec | comma" outlined dense hide-details readonly></v-text-field>
                  <v-text-field :value="db.inscnt | comma" outlined dense hide-details readonly></v-text-field>
                  <div></div>
                  <v-text-field :value="db.phyinscnt | comma" outlined dense hide-details readonly></v-text-field>
                  <v-text-field :value="db.insti | millis | comma" outlined dense hide-details readonly></v-text-field>
                  <v-text-field :value="(Math.floor(db.insti / (db.insrec === 0 ? 1 : db.insrec) / 100) / 10) | comma" outlined dense hide-details readonly></v-text-field>
                </div>
              </v-col>
            </v-row>
          </fieldset>
        </v-col>
      </v-row>
    </fieldset>
  </div>
</template>

<script>
import { api } from '../../../api/common/instances';
import tabable from './tabable';

export default {
  mixins: [tabable],
  data() {
    return {
      dbrecs: [],
    };
  },
  methods: {
    async fetch(params) {
      // eslint-disable-next-line prettier/prettier
      ({ data: this.dbrecs } = await api.get('/analysis/ssrviewer/detail/dbrecs', { params }));
      this.increaseLoadingCount();
    },
    average(db) {
      const total = db.readdirrec + db.readseqrec + db.updrec + db.delrec + db.insrec;
      return (db.readdirti + db.readseqti + db.updti + db.delti + db.insti) / (total == 0 ? 1 : total);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './tab';
div.input-list * {
  width: 16.6%;
  text-align: left;
}
div.input-list .v-input {
  margin-right: 5px;
}
</style>
